<template>
    <v-checkbox v-if="isShow" v-model="commissionAndNettoCheckbox" hide-details data-cy="commission-and-netto-checkbox">
        <template v-slot:label>
            <span class="text-body-2">
                {{ $t('show_commission_and_net_amount') }}
            </span>
        </template>
    </v-checkbox>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    @Component
    export class ShowCommissionAndNettoCheckbox extends Vue {
        async mounted() {
            await this.$store.restored
            this.load()
        }

        load() {
            if (!(this.isAgency || this.isTourOperator)) {
                persistentStore.SET_COMMISSION_AND_NETTO_CHECKBOX(true)
            }
            if (this.isTourOperator && this.personRole === 'dispatcher') {
                persistentStore.SET_COMMISSION_AND_NETTO_CHECKBOX(false)
            }
        }

        get commissionAndNettoCheckbox() {
            return persistentStore.commissionAndNettoCheckbox
        }

        set commissionAndNettoCheckbox(val) {
            persistentStore.SET_COMMISSION_AND_NETTO_CHECKBOX(val)
        }

        get isAgency() {
            return authStore.isAgency
        }

        get isTourOperator() {
            return authStore.isTourOperator
        }

        get personRole() {
            return authStore.personRole
        }

        get isShow() {
            return true
        }
    }

    export default ShowCommissionAndNettoCheckbox
</script>
